module.exports = __webpack_public_path__ + "coin_SMARTCASH.png?4ad5ca745eb8f10a8329e2ab326458ea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_SMARTCASH.png
// module id = 1114
// module chunks = 2